import { h, ref, onMounted } from 'vue';

// 借助 “高阶函数”，动态的提供组件上下文
export function withProvider(Component, setups) {
	return {
		props: ['forwardRef'], // 用于传递内部组件实例的回调
		setup(props, ctx) {
			// Provide Context
			setups && setups();

			// 内部 ref 指向原组件实例
			const innerRef = ref(null);

			// 挂载完成后，把内部实例回调给父组件
			onMounted(() => {
				props.forwardRef?.(innerRef.value);
			});

			return () =>
				h(Component, {
					props,
					on: ctx.listeners,
					attrs: ctx.attrs,
					ref: innerRef,
					scopedSlots: ctx.slots
				});
		}
	};
}
